import { useState } from "react";
import { ChevronDown } from "lucide-react";

// Banner-menu a tendina riutilizzabile (solo UI). Header cliccabile che
// espande/chiude il contenuto sottostante.
export function CollapsibleSection({ icon, title, testid, defaultOpen = false, right, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="rounded-xl border border-white/10 bg-[#181D22] overflow-hidden">
      <button
        data-testid={testid}
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-2 p-4 text-left hover:bg-white/5 transition-colors"
      >
        {icon}
        <span className="text-sm font-bold flex-1">{title}</span>
        {right}
        <ChevronDown size={18} className={`text-[#94A3B8] transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-4 pb-4 pt-0">{children}</div>}
    </div>
  );
}
